const rankings = [
  { rank: 1, title: '斗破苍穹', genre: '热血·奇幻', heat: '982万', status: '已完结', trend: 'up' },
  { rank: 2, title: '海贼王', genre: '热血·冒险', heat: '956万', status: '连载中', trend: 'stable' },
  { rank: 3, title: '鬼灭之刃', genre: '热血·战斗', heat: '921万', status: '已完结', trend: 'up' },
  { rank: 4, title: '狐妖小红娘', genre: '恋爱·奇幻', heat: '887万', status: '连载中', trend: 'up' },
  { rank: 5, title: '一人之下', genre: '奇幻·都市', heat: '854万', status: '连载中', trend: 'stable' },
  { rank: 6, title: '名侦探柯南', genre: '悬疑·推理', heat: '812万', status: '连载中', trend: 'stable' },
  { rank: 7, title: '镇魂街', genre: '热血·奇幻', heat: '789万', status: '连载中', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">全网漫迷用热度投票的<strong>免费漫画全集</strong>人气榜单</p>
        </div>
        <div className="max-w-[800px] mx-auto bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 border-b border-background-100 last:border-b-0 hover:bg-background-100/50 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm md:text-base font-heading text-foreground-900 whitespace-nowrap">{item.title}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">{item.genre}</span>
                </div>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-foreground-400">热度 {item.heat}</span>
                  <span className="text-xs text-foreground-400">{item.status}</span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <i className={`text-lg ${
                  item.trend === 'up' ? 'ri-arrow-up-line text-accent-500' : 'ri-subtract-line text-foreground-400'
                }`}></i>
                <i className="ri-arrow-right-s-line text-foreground-300"></i>
              </div>
            </a>
          ))}
        </div>
        <div className="text-center mt-6">
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看完整排行榜
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}